module.exports = __webpack_public_path__ + "img/denglu-button@2x.5f386ad6.png";